/**
 * Shared timer resume helper for Step1/Step2.
 * Builds a session-scoped localStorage key and derives initialInnerStep from
 * whether a timer was already started (key present → skip to step 2).
 */
import { useMemo } from 'react'
import { useAppSelector } from 'store/hooks'
import { getSessionId } from 'store/slices/test'

interface TimerResumeResult {
  timerKey: string
  initialInnerStep: number
}

const useTimerResume = (stepPrefix: string): TimerResumeResult => {
  const sessionId = useAppSelector(getSessionId)
  const timerKey = sessionId ? `${stepPrefix}_${sessionId}` : stepPrefix

  const initialInnerStep = useMemo(() => {
    try {
      return localStorage.getItem(timerKey) ? 2 : 1
    } catch {
      return 1
    }
  }, [timerKey])

  return { timerKey, initialInnerStep }
}

export default useTimerResume
